// Brand logos - using real PNGs hosted as public assets.
export const sapLogo = "/brand/sap.png";
export const steadfastLogo = "/brand/steadfast.png";
